import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    MagicPhoneAuthParams,
    PhoneNumberParams,
    postMagicPhoneAuth,
    postPhoneNumber,
    postPhoneNumberCall
} from "../actions";
import { push } from "connected-react-router";
import { Route, Switch } from "react-router";
import { loggedIn, magicInProgress } from "../../util";
import PhoneNumberScreen from "../components/PhoneNumberScreen";
import PhoneAuthScreen from "../components/PhoneAuthScreen";
import { colors } from "../../constants";
import { fetchRecaptchaToken } from "src/util/recaptcha";

interface Props {
    postPhoneNumber: (phoneNumberParams: PhoneNumberParams) => void;
    postPhoneNumberResend: (phoneNumberParams: PhoneNumberParams) => void;
    postPhoneNumberCall: (phoneNumberParams: PhoneNumberParams) => void;
    postMagicPhoneAuth: (params: MagicPhoneAuthParams) => void;
    push: (route: string) => void;
}

const PhoneAuth = ({
    postPhoneNumber,
    postPhoneNumberResend,
    postPhoneNumberCall,
    postMagicPhoneAuth,
    push
}: Props) => {
    const magicToken = localStorage.getItem("magicToken");

    if (!magicInProgress()) {
        push("/onboarding");
    } else if (loggedIn()) {
        push("/onboarding");
    }

    useEffect(() => {
        document.body.style.backgroundColor = colors.primaryBlue;

        return () => {
            document.body.style.backgroundColor = "";
        };
    }, []);

    const [phoneNumber, setPhoneNumber] = useState("");
    const [authCode, setAuthCode] = useState("");

    useEffect(() => {
        if (authCode.length === 4 && phoneNumber.length > 0 && magicToken) {
            postMagicPhoneAuth({ phoneNumber, authCode, magicToken });
        }
    }, [authCode]);

    return (
        <Switch>
            <Route
                path="/approved/phone/auth"
                render={() => {
                    return (
                        <PhoneAuthScreen
                            backClicked={() => push("/approved/phone")}
                            phoneNumber={phoneNumber}
                            authCode={authCode}
                            setAuthCode={setAuthCode}
                            resendClicked={async () => {
                                console.log('[Auth][Magic] Resend requested, acquiring reCAPTCHA token (phone_auth_resend)');
                                const recaptchaToken = await fetchRecaptchaToken("login");
                                console.log('[Auth][Magic] reCAPTCHA token (resend) acquired?', !!recaptchaToken);
                                if (!recaptchaToken) {
                                    console.warn('[Auth][Magic] Blocking resend dispatch: reCAPTCHA token missing (phone_auth_resend)');
                                    return;
                                }
                                postPhoneNumberResend({ phoneNumber, recaptchaToken });
                            }}
                            callClicked={async () => {
                                console.log('[Auth][Magic] Voice call requested, acquiring reCAPTCHA token (phone_auth_call)');
                                const recaptchaToken = await fetchRecaptchaToken("login");
                                console.log('[Auth][Magic] reCAPTCHA token (call) acquired?', !!recaptchaToken);
                                if (!recaptchaToken) {
                                    console.warn('[Auth][Magic] Blocking voice call dispatch: reCAPTCHA token missing (phone_auth_call)');
                                    return;
                                }
                                postPhoneNumberCall({ phoneNumber, recaptchaToken });
                            }}
                        />
                    );
                }}
            />
            <Route
                path="/approved/phone"
                render={props => {
                    return (
                        <PhoneNumberScreen
                            phoneNumber={phoneNumber}
                            setPhoneNumber={setPhoneNumber}
                            nextClicked={async () => {
                                console.log('[Auth][Magic] Start auth requested, acquiring reCAPTCHA token (login)');
                                const recaptchaToken = await fetchRecaptchaToken("login");
                                console.log('[Auth][Magic] reCAPTCHA token (start) acquired?', !!recaptchaToken);
                                if (!recaptchaToken) {
                                    console.warn('[Auth][Magic] Blocking start dispatch: reCAPTCHA token missing (login)');
                                    return;
                                }
                                postPhoneNumber({ phoneNumber, recaptchaToken });
                            }}
                        />
                    );
                }}
            />
        </Switch>
    );
};

const mapDispatchToProps = (dispatch: any) => ({
    postPhoneNumber: (phoneNumberRequest: PhoneNumberParams) =>
        dispatch(postPhoneNumber(phoneNumberRequest)),
    postPhoneNumberResend: (phoneNumberRequest: PhoneNumberParams) =>
        dispatch(postPhoneNumber(phoneNumberRequest)),
    postPhoneNumberCall: (phoneNumberRequest: PhoneNumberParams) =>
        dispatch(postPhoneNumberCall(phoneNumberRequest)),
    postMagicPhoneAuth: (params: MagicPhoneAuthParams) =>
        dispatch(postMagicPhoneAuth(params)),
    push: (route: string) => dispatch(push(route))
});

export default connect(null, mapDispatchToProps)(PhoneAuth);
